import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component } from './component';

export class ExpandButtonBuilder
  implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return formatConfig?.expandBtn?.showExpandBtn === true;
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return Component;
  }
}
